enum RunningStatus {
  RUNNING = 'RUNNING',
  FINISHED = 'FINISHED',
  PAUSED = 'PAUSED',
}
export default RunningStatus;
